<template>
  <div>
    <img
      v-if="pageType !== 'video'"
      :src="source"
      :alt="alt"
    >
    <video
      v-else
      controls
    >
      <source
        :src="source"
        :type="fileType"
      >
    </video>
  </div>
</template>

<script>
  export default {
    props: {
      pageType: {
        type: String,
        required: true
      },
      fileType: {
        type: String,
        required: true
      },
      source: {
        type: String,
        required: true
      },
      alt: {
        type: String,
        required: true
      }
    }
  }
</script>

<style lang="scss" scoped rel="stylesheet/scss">
  img,
  video {
    max-height: 80vh;
    max-width: 100%;
  }
</style>
